var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:"validator",attrs:{"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('v-form',_vm._b({},'v-form',_vm.$attrs,false),[_vm._t("default",null,{"errors":errors,"onSubmit":_vm.onSubmit,"resetError":_vm.resetError})],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }